export enum FarmerTierHistoryType {
  Earned = 'earned',
  Override = 'override',
  Rollover = 'rollover',
}